module.exports = __webpack_public_path__ + "static/media/icon2.693ec409.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/icon2.jpg
// module id = 56
// module chunks = 0